import { create } from "zustand";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const statuses = [
  "detected",
  "suspicious",
  "reported",
  "takenDown",
  "whitelisted",
  "testPurchase",
  "uncrawled",
  "nonCompliance",
  "nonReportable"
];

const statusMap = {
  suspicious: "S",
  whitelisted: "W",
  detected: "D",
  reported: "R",
  takenDown: "TD",
  testPurchase: "T",
  nonCompliance: "NC",
  uncrawled: "U",
  nonReportable: "NR"

};

export const useProductStore = create((set, get) => ({
  products: {},
  loading: false,
  pendingProducts: {},

  fetchProductsByStatus: async (status) => {
    const userInfo = JSON.parse(localStorage.getItem("PAuser"));
    set({ loading: true });
    try {
      const response = await fetch(`${backendUrl}/api/products/byStatus`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
          status: status
        })
      });

      const json = await response.json();

      if (response.ok) {
        const categoryMap = {
          'W': 'whitelisted',
          'S': 'suspicious',
          'R': 'reported',
          'TD': 'takenDown',
          'T': 'testPurchase',
          'NC': 'nonCompliance',
          'NR': 'nonReportable'
        };
        const category = categoryMap[status];
        if (category) {
          await get().updateProducts(json, category);
          return json;
        }
      }
      throw new Error(json.message || 'Failed to fetch products');
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    } finally {
      set({ loading: false });
    }
  },

  updateProducts: async (newProducts, status) => {
    set({ loading: true });
    try {
      const currentProducts = get().products[status] || [];

      // Create a Set of existing IDs for faster lookup
      const existingIds = new Set(currentProducts.map(prod => prod.psm_id));

      // Filter out duplicates
      const uniqueProducts = newProducts.filter(newProd => !existingIds.has(newProd.psm_id));

      const updated = {
        ...get().products,
        [status]: [...currentProducts, ...uniqueProducts]
      };

      set({ products: updated });
      console.log("products",updated);
      return updated;
    } finally {
      set({ loading: false });
    }
  },


  updateProductField: (category, pd_ids, text) => {
    set((state) => {
      console.log("im from store", pd_ids)
      const updatedProducts = state.products[category]?.map((product) => {
        if (pd_ids.includes(product.pd_id)) {
          console.log("im from store product", product.pd_id)
          // Only update the brand_image_check field to 6
          return { ...product, brand_image_check: text };
        }
        return product;
      });

      return {
        products: {
          ...state.products,
          [category]: [...updatedProducts], // force new reference
        }
      };
    });
  },




  moveProducts: async (fromCategory, productsToMove, toCategory) => {
    set({ loading: true });
    try {
      const store = get();
      const products = store.products;
      const productsArray = Array.isArray(productsToMove)
        ? productsToMove
        : [productsToMove];

      // Create new object to avoid state mutations
      const updatedProducts = { ...products };

      // Remove from source category
      if (updatedProducts[fromCategory]) {
        const idsToRemove = new Set(
          productsArray.map((p) => (typeof p === "object" ? p.psm_id : p))
        );
        updatedProducts[fromCategory] = updatedProducts[fromCategory].filter(
          (p) => !idsToRemove.has(p.psm_id ?? p.pd_id)
        );
      }

      // Initialize target category if it doesn't exist
      if (!updatedProducts[toCategory]) {
        try {
          const fetchedProducts = await get().fetchProductsByStatus(
            statusMap[toCategory] || toCategory
          );
          updatedProducts[toCategory] = fetchedProducts || [];
        } catch (error) {
          console.error("Error fetching products for category:", error);
          updatedProducts[toCategory] = [];
        }
      }

      // Add to target category with updated status
      const movedWithNewStatus = productsArray.map((p) => ({
        ...(typeof p === "object"
          ? p
          : products[fromCategory].find((prod) => prod.psm_id === p)),
        status: statusMap[toCategory] || toCategory,
      }));

      // Filter out any undefined values that might have occurred during the mapping
      const validMovedProducts = movedWithNewStatus.filter(Boolean);

      // Deduplicate by psm_id before adding to the target category
      const existingTargetIds = new Set(
        updatedProducts[toCategory].map((prod) => prod.psm_id ?? prod.pd_id)
      );
      const deduplicatedProducts = validMovedProducts.filter(
        (prod) => !existingTargetIds.has(prod.psm_id ?? prod.pd_id)
      );

      updatedProducts[toCategory] = [
        ...updatedProducts[toCategory],
        ...deduplicatedProducts,
      ];

      set({ products: updatedProducts });
      return updatedProducts;
    } catch (err) {
      console.error("Move error:", err);
      throw err;
    } finally {
      set({ loading: false });
    }
  },

  cleanupPendingProducts: () => {
    const { pendingProducts, products } = get();

    const updated = { ...products };
    const clearedPending = {};

    Object.entries(pendingProducts).forEach(([category, list]) => {
      if (list && list.length > 0) {
        updated[category] = [...(updated[category] || []), ...list];
        clearedPending[category] = [];
      }
    });

    set({ products: updated, pendingProducts: clearedPending });
  },
}));
